<template>
  <div id="lom-events-create">
    <v-overlay :value="OverlayLoadingFlag">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>

    <!-- Professional Page Header -->
    <div class="premium-header-section mb-8">
      <div class="header-overlay"></div>
      <v-container>
        <div class="header-content-wrapper">
          <div class="header-text-group">
            <h1 class="premium-page-title">{{ PageTitle }}</h1>
            <p class="premium-page-subtitle">{{ PageDescription }}</p>
          </div>
          <div class="header-actions-group">
            <v-btn
              @click.prevent="backPage"
              rounded
              elevation="0"
              class="glass-btn mr-3"
            >
              <v-icon left> mdi-arrow-left </v-icon>
              Back
            </v-btn>
            <v-btn
              @click.prevent="refreshPageData"
              rounded
              elevation="4"
              color="white"
              class="refresh-btn text-primary"
            >
              <v-icon left color="primary"> mdi-refresh </v-icon>
              Refresh
            </v-btn>
          </div>
        </div>
      </v-container>
    </div>

    <!-- Main Content Area -->
    <v-container class="mt-n16 pt-0">
      <v-card elevation="12" class="glass-main-card">
        <v-card-text class="pa-8">
          <v-container fluid class="px-0">
            <v-card
              elevation="0"
              class="premium-welcome-card mb-10"
              v-if="MemeberFullname != ''"
            >
              <v-card-text class="pa-10">
                <v-row align="center">
                  <v-col cols="auto">
                    <div class="welcome-avatar-wrapper">
                      <v-avatar size="100" class="elevation-10">
                        <v-icon size="60" color="primary"
                          >mdi-account-circle</v-icon
                        >
                      </v-avatar>
                      <div class="avatar-badge">
                        <v-icon small color="white">mdi-check</v-icon>
                      </div>
                    </div>
                  </v-col>
                  <v-col>
                    <span class="welcome-label">Logged in as</span>
                    <h2 class="welcome-title mb-1">
                      Welcome, {{ MemeberFullname }}
                    </h2>
                    <div class="welcome-meta">
                      <span class="meta-item">
                        <v-icon small left color="primary"
                          >mdi-badge-account</v-icon
                        >
                        {{ CurrentDesignation }}
                      </span>
                      <span class="meta-divider"></span>
                      <span class="meta-item">
                        <v-icon small left color="primary"
                          >mdi-office-building</v-icon
                        >
                        {{ LomName }}
                      </span>
                    </div>
                  </v-col>
                  <v-col cols="auto" class="hidden-sm-and-down">
                    <div class="year-badge">
                      <span class="year-label">Year</span>
                      <span class="year-value">{{ YearName }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
              <b-spinner
                variant="primary"
                type="grow"
                label="Loading..."
              ></b-spinner>
            </div>

            <v-form
              ref="form1"
              v-model="valid1"
              lazy-validation
              v-on:submit.prevent="confirmAlert"
            >
              <!-- Student Details Section -->
              <v-card elevation="0" class="section-card mb-6">
                <v-card-title class="section-header">
                  <v-icon left color="primary" size="28"
                    >mdi-account-school</v-icon
                  >
                  <span class="section-title">Student Details</span>
                  <v-spacer></v-spacer>
                  <v-chip small color="white" outlined>Required</v-chip>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                  <v-container fluid>
                    <v-row wrap>
                      <v-col cols="12" sm="6" lg="6" md="6" id="step6">
                        <label class="field-label">
                          Student Name <span class="required-asterisk">*</span>
                        </label>
                        <v-text-field
                          v-model="StudentName"
                          :rules="StudentNameRules"
                          outlined
                          dense
                          placeholder="Enter student's full name"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="6" md="6">
                        <label class="field-label">
                          Gender <span class="required-asterisk">*</span>
                        </label>
                        <v-autocomplete
                          :reduce="(option) => option.value"
                          :items="StudentGenderOptions"
                          :rules="StudentGenderRules"
                          v-model="StudentGender"
                          dense
                          clearable
                          required
                          outlined
                          placeholder="Select gender"
                          hide-details="auto"
                          class="modern-input"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row wrap>
                      <v-col cols="12" sm="6" lg="4" md="4">
                        <label class="field-label">
                          Scholarship Type
                          <span class="required-asterisk">*</span>
                        </label>
                        <v-autocomplete
                          :reduce="(option) => option.value"
                          :items="ScholarshipTypeItems"
                          :rules="ScholarshipTypeRules"
                          v-model="ScholarshipType"
                          dense
                          clearable
                          required
                          outlined
                          placeholder="Select scholarship type"
                          hide-details="auto"
                          class="modern-input"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" lg="4" md="4" id="step6">
                        <label class="field-label">
                          Class/Standard
                          <span class="required-asterisk">*</span>
                        </label>
                        <v-autocomplete
                          :items="StudentClassNameOptions"
                          v-model="StudentClassName"
                          :rules="StudentClassNameRules"
                          item-text="text"
                          item-value="value"
                          dense
                          clearable
                          required
                          outlined
                          placeholder="Select class"
                          hide-details="auto"
                          class="modern-input"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" lg="4" md="4" id="step6">
                        <label class="field-label">
                          Total Marks <span class="required-asterisk">*</span>
                        </label>
                        <v-text-field
                          v-model="TotalMark"
                          :rules="TotalMarkRules"
                          outlined
                          dense
                          placeholder="Enter total marks obtained"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="4" md="4" id="step6">
                        <label class="field-label">
                          Percentage <span class="required-asterisk">*</span>
                        </label>
                        <v-text-field
                          v-model="Percentage"
                          :rules="PercentageRules"
                          outlined
                          dense
                          placeholder="Enter percentage"
                          suffix="%"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="4" md="4" id="step6">
                        <label class="field-label">
                          Contact Number
                          <span class="required-asterisk">*</span>
                        </label>
                        <v-text-field
                          v-model="StudentContactNumber"
                          :rules="StudentContactNumberRules"
                          outlined
                          dense
                          placeholder="Enter 10-digit mobile number"
                          :counter="10"
                          v-mask="'##########'"
                          type="number"
                          prefix="+91"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="4" md="4">
                        <label class="field-label">
                          Special Category
                          <span class="required-asterisk">*</span>
                        </label>
                        <v-autocomplete
                          :reduce="(option) => option.value"
                          :items="SpecialCategoryOptions"
                          :rules="SpecialCategoryRules"
                          v-model="SpecialCategory"
                          dense
                          clearable
                          required
                          outlined
                          placeholder="Select special category"
                          hide-details="auto"
                          class="modern-input"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row wrap class="mt-4">
                      <v-col cols="12">
                        <v-divider class="mb-4"></v-divider>
                      </v-col>
                      <v-col cols="12" sm="6" lg="6" md="6">
                        <h3 class="subsection-title mb-4">
                          <v-icon left color="primary">mdi-camera</v-icon>
                          Student Photograph
                        </h3>
                        <label class="field-label"
                          >Upload Photo<span class="required-asterisk"
                            >*</span
                          ></label
                        >
                        <div class="image-preview-container">
                          <div
                            v-if="StudentImageCropping"
                            class="cropper-wrapper"
                          >
                            <cropper
                              :src="StudentImageFile"
                              ref="cropper"
                              :stencil-props="{
                                handlers: {},
                                movable: true,
                                scalable: true,
                                aspectRatio: 1,
                                previewClass: 'preview',
                              }"
                              class="modern-cropper"
                            />
                            <div class="cropper-actions mt-3">
                              <v-btn
                                @click="cropAndUpload('studentImage')"
                                color="success"
                                small
                                block
                                class="mb-2"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Apply Crop
                              </v-btn>
                              <v-btn
                                @click="cancelCrop('studentImage')"
                                color="error"
                                small
                                outlined
                                block
                              >
                                <v-icon small left>mdi-close</v-icon>
                                Cancel
                              </v-btn>
                            </div>
                          </div>
                          <div
                            v-else
                            class="image-placeholder"
                            @click="triggerFileInput('studentImage')"
                            @dragover.prevent="StudentImageDragging = true"
                            @dragleave.prevent="StudentImageDragging = false"
                            @drop.prevent="handleDrop($event, 'studentImage')"
                            :class="{ dragging: StudentImageDragging }"
                          >
                            <input
                              :ref="'studentImageFileInput'"
                              type="file"
                              accept="image/jpeg,image/png"
                              @change="onFileSelected($event, 'studentImage')"
                              style="display: none"
                            />
                            <div
                              v-if="!StudentImagePreview"
                              class="placeholder-content"
                            >
                              <v-icon size="48" color="#002D72" class="mb-2"
                                >mdi-cloud-upload</v-icon
                              >
                              <p class="font-weight-600">Drag & Drop Here</p>
                              <p class="text-caption">
                                or click to select image
                              </p>
                            </div>
                            <v-img
                              v-else
                              :src="StudentImagePreview"
                              contain
                              height="280"
                            />
                          </div>
                          <v-btn
                            v-if="StudentImagePreview"
                            @click="removeImage('studentImage')"
                            color="error"
                            variant="outlined"
                            class="mt-3"
                            size="small"
                            block
                          >
                            <v-icon small left>mdi-trash-can</v-icon>
                            Remove Image
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col
                        v-if="
                          SpecialCategory &&
                          SpecialCategory !== '' &&
                          SpecialCategory !== 1
                        "
                        cols="12"
                        sm="6"
                        lg="6"
                        md="6"
                      >
                        <h3 class="subsection-title mb-4">
                          <v-icon left color="primary"
                            >mdi-file-document</v-icon
                          >
                          {{ specialCategoryTitle }}
                        </h3>
                        <v-alert
                          type="warning"
                          border="left"
                          colored-border
                          dense
                          elevation="2"
                          class="mb-4 text-left"
                          v-slot:default
                          v-if="specialCategoryNote"
                        >
                          <span class="font-weight-600">
                            {{ specialCategoryNote }}
                          </span>
                        </v-alert>
                        <label class="field-label">
                          {{ specialCategoryLabel }}
                          <span class="required-asterisk">*</span>
                        </label>
                        <div class="image-preview-container">
                          <div
                            v-if="SpecialCategoryDocumentCropping"
                            class="cropper-wrapper"
                          >
                            <cropper
                              :src="SpecialCategoryDocumentFile"
                              ref="specialCategoryCropper"
                              :stencil-props="{
                                handlers: {},
                                movable: true,
                                scalable: true,
                                previewClass: 'preview',
                              }"
                              class="modern-cropper"
                            />
                            <div class="cropper-actions mt-3">
                              <v-btn
                                @click="cropAndUpload('specialCategory')"
                                color="success"
                                small
                                block
                                class="mb-2"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Apply Crop
                              </v-btn>
                              <v-btn
                                @click="cancelCrop('specialCategory')"
                                color="error"
                                small
                                outlined
                                block
                              >
                                <v-icon small left>mdi-close</v-icon>
                                Cancel
                              </v-btn>
                            </div>
                          </div>
                          <div
                            v-else
                            class="image-placeholder"
                            @click="triggerFileInput('specialCategory')"
                            @dragover.prevent="
                              SpecialCategoryDocumentDragging = true
                            "
                            @dragleave.prevent="
                              SpecialCategoryDocumentDragging = false
                            "
                            @drop.prevent="
                              handleDrop($event, 'specialCategory')
                            "
                            :class="{
                              dragging: SpecialCategoryDocumentDragging,
                            }"
                          >
                            <input
                              :ref="'specialCategoryFileInput'"
                              type="file"
                              accept="image/jpeg,image/png"
                              @change="
                                onFileSelected($event, 'specialCategory')
                              "
                              style="display: none"
                            />
                            <div
                              v-if="!SpecialCategoryDocumentPreview"
                              class="placeholder-content"
                            >
                              <v-icon size="40" color="#002D72" class="mb-2"
                                >mdi-cloud-upload</v-icon
                              >
                              <p class="font-weight-600">Drag & Drop Here</p>
                              <p class="text-caption">
                                or click to select image
                              </p>
                            </div>
                            <v-img
                              v-else
                              :src="SpecialCategoryDocumentPreview"
                              contain
                              height="280"
                            />
                          </div>
                          <v-btn
                            v-if="SpecialCategoryDocumentPreview"
                            @click="removeImage('specialCategory')"
                            color="error"
                            variant="outlined"
                            class="mt-3"
                            size="small"
                            block
                          >
                            <v-icon small left>mdi-trash-can</v-icon>
                            Remove Image
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>

              <!-- Parents Details Section -->
              <v-card elevation="0" class="section-card mb-6">
                <v-card-title class="section-header">
                  <v-icon left color="primary" size="28"
                    >mdi-account-group</v-icon
                  >
                  <span class="section-title">Parents Details</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                  <v-container fluid>
                    <v-row wrap>
                      <v-col cols="12" sm="6" lg="6" md="6" id="step7">
                        <label class="field-label">
                          Parent/Guardian Name
                          <span class="required-asterisk">*</span></label
                        >
                        <v-text-field
                          v-model="ParentName"
                          :rules="ParentNameRules"
                          outlined
                          dense
                          placeholder="Enter parent/guardian name"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="6" md="6" id="step7">
                        <label class="field-label">
                          Occupation
                          <span class="required-asterisk">*</span></label
                        >
                        <v-text-field
                          v-model="ParentOccupation"
                          :rules="ParentOccupationRules"
                          outlined
                          dense
                          placeholder="Enter occupation"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="6" md="6" id="step7">
                        <label class="field-label">
                          Contact Number
                          <span class="required-asterisk">*</span></label
                        >
                        <v-text-field
                          v-model="ParentContactNumber"
                          :rules="ParentContactNumberRules"
                          outlined
                          dense
                          placeholder="Enter 10-digit mobile number"
                          :counter="10"
                          v-mask="'##########'"
                          type="number"
                          prefix="+91"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="6" md="6" id="step7">
                        <label class="field-label">
                          Annual Income
                          <span class="required-asterisk">*</span></label
                        >
                        <v-text-field
                          v-model="AnnualIncome"
                          :rules="AnnualIncomeRules"
                          outlined
                          dense
                          placeholder="Enter annual income"
                          prefix="₹"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>

              <!-- School Details Section -->
              <v-card elevation="0" class="section-card mb-6">
                <v-card-title class="section-header">
                  <v-icon left color="primary" size="28">mdi-school</v-icon>
                  <span class="section-title">School Details</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                  <v-container fluid>
                    <v-row wrap>
                      <v-col cols="12" sm="6" lg="6" md="6" id="step7">
                        <label class="field-label">
                          Principal Name
                          <span class="required-asterisk">*</span></label
                        >
                        <v-text-field
                          v-model="PrincipalName"
                          :rules="PrincipalNameRules"
                          outlined
                          dense
                          placeholder="Enter principal name"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="6" md="6" id="step7">
                        <label class="field-label">
                          School Name
                          <span class="required-asterisk">*</span></label
                        >
                        <v-text-field
                          v-model="SchoolName"
                          :rules="SchoolNameRules"
                          outlined
                          dense
                          placeholder="Enter school name"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="6" md="6" id="step7">
                        <label class="field-label">
                          School Address
                          <span class="required-asterisk">*</span></label
                        >
                        <v-text-field
                          v-model="SchoolAddress"
                          :rules="SchoolAddressRules"
                          outlined
                          dense
                          placeholder="Enter complete school address"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="6" md="6" id="step7">
                        <label class="field-label">
                          School Contact Number
                          <span class="required-asterisk">*</span></label
                        >
                        <v-text-field
                          v-model="SchoolCantactNumber"
                          :rules="SchoolCantactNumberRules"
                          outlined
                          dense
                          placeholder="Enter school contact number"
                          :counter="10"
                          v-mask="'##########'"
                          type="number"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" lg="12" md="12" id="step7">
                        <label class="field-label">
                          Sponsor Name (Optional)
                        </label>
                        <v-text-field
                          v-model="SponsorName"
                          :rules="SponsorNameRules"
                          outlined
                          dense
                          placeholder="Enter sponsor name (if any)"
                          hide-details="auto"
                          class="modern-input"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>

              <!-- Attachments Section -->
              <v-card elevation="0" class="section-card mb-6">
                <v-card-title class="section-header">
                  <v-icon left color="primary" size="28">mdi-paperclip</v-icon>
                  <span class="section-title">Supporting Documents</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                  <v-row class="file-input-row">
                    <v-col cols="12" sm="4" md="4" lg="4">
                      <label class="field-label"
                        >Annual income certificate of parent OR Principal
                        certificate for parents income
                        <span class="required-asterisk">*</span></label
                      >
                      <div class="image-preview-container">
                        <div
                          v-if="AnnualIncomeLetterCropping"
                          class="cropper-wrapper"
                        >
                          <cropper
                            :src="AnnualIncomeLetterFile"
                            ref="annualIncomeCropper"
                            :stencil-props="{
                              handlers: {},
                              movable: true,
                              scalable: true,
                              previewClass: 'preview',
                            }"
                            class="modern-cropper"
                          />
                          <div class="cropper-actions mt-3">
                            <v-btn
                              @click="cropAndUpload('annualIncome')"
                              color="success"
                              small
                              block
                              class="mb-2"
                            >
                              <v-icon small left>mdi-check</v-icon>
                              Apply Crop
                            </v-btn>
                            <v-btn
                              @click="cancelCrop('annualIncome')"
                              color="error"
                              small
                              outlined
                              block
                            >
                              <v-icon small left>mdi-close</v-icon>
                              Cancel
                            </v-btn>
                          </div>
                        </div>
                        <div
                          v-else
                          class="image-placeholder"
                          @click="triggerFileInput('annualIncome')"
                          @dragover.prevent="AnnualIncomeLetterDragging = true"
                          @dragleave.prevent="
                            AnnualIncomeLetterDragging = false
                          "
                          @drop.prevent="handleDrop($event, 'annualIncome')"
                          :class="{ dragging: AnnualIncomeLetterDragging }"
                        >
                          <input
                            :ref="'annualIncomeFileInput'"
                            type="file"
                            accept="image/jpeg,image/png"
                            @change="onFileSelected($event, 'annualIncome')"
                            style="display: none"
                          />
                          <div
                            v-if="!AnnualIncomeLetterPreview"
                            class="placeholder-content"
                          >
                            <v-icon size="48" color="#002D72" class="mb-2"
                              >mdi-cloud-upload</v-icon
                            >
                            <p class="font-weight-600">Drag & Drop Here</p>
                            <p class="text-caption">or click to select image</p>
                          </div>
                          <v-img
                            v-else
                            :src="AnnualIncomeLetterPreview"
                            contain
                            height="280"
                          />
                        </div>
                        <v-btn
                          v-if="AnnualIncomeLetterPreview"
                          @click="removeImage('annualIncome')"
                          color="error"
                          variant="outlined"
                          class="mt-3"
                          size="small"
                          block
                        >
                          <v-icon small left>mdi-trash-can</v-icon>
                          Remove Image
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="4" md="4" lg="4">
                      <label class="field-label"
                        >Mark Sheet/Report Card
                        <span class="required-asterisk">*</span></label
                      >
                      <div class="image-preview-container">
                        <div
                          v-if="StudentMarkImageCropping"
                          class="cropper-wrapper"
                        >
                          <cropper
                            :src="StudentMarkImageFile"
                            ref="markImageCropper"
                            :stencil-props="{
                              handlers: {},
                              movable: true,
                              scalable: true,
                              previewClass: 'preview',
                            }"
                            class="modern-cropper"
                          />
                          <div class="cropper-actions mt-3">
                            <v-btn
                              @click="cropAndUpload('studentMark')"
                              color="success"
                              small
                              block
                              class="mb-2"
                            >
                              <v-icon small left>mdi-check</v-icon>
                              Apply Crop
                            </v-btn>
                            <v-btn
                              @click="cancelCrop('studentMark')"
                              color="error"
                              small
                              outlined
                              block
                            >
                              <v-icon small left>mdi-close</v-icon>
                              Cancel
                            </v-btn>
                          </div>
                        </div>
                        <div
                          v-else
                          class="image-placeholder"
                          @click="triggerFileInput('studentMark')"
                          @dragover.prevent="StudentMarkImageDragging = true"
                          @dragleave.prevent="StudentMarkImageDragging = false"
                          @drop.prevent="handleDrop($event, 'studentMark')"
                          :class="{ dragging: StudentMarkImageDragging }"
                        >
                          <input
                            :ref="'studentMarkFileInput'"
                            type="file"
                            accept="image/jpeg,image/png"
                            @change="onFileSelected($event, 'studentMark')"
                            style="display: none"
                          />
                          <div
                            v-if="!StudentMarkImagePreview"
                            class="placeholder-content"
                          >
                            <v-icon size="48" color="#002D72" class="mb-2"
                              >mdi-cloud-upload</v-icon
                            >
                            <p class="font-weight-600">Drag & Drop Here</p>
                            <p class="text-caption">or click to select image</p>
                          </div>
                          <v-img
                            v-else
                            :src="StudentMarkImagePreview"
                            contain
                            height="280"
                          />
                        </div>
                        <v-btn
                          v-if="StudentMarkImagePreview"
                          @click="removeImage('studentMark')"
                          color="error"
                          variant="outlined"
                          class="mt-3"
                          size="small"
                          block
                        >
                          <v-icon small left>mdi-trash-can</v-icon>
                          Remove Image
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Bank Details Section -->
              <v-card elevation="0" class="section-card mb-6">
                <v-card-title class="section-header">
                  <v-icon left color="primary" size="28">mdi-bank</v-icon>
                  <span class="section-title">Bank Account Information</span>
                  <v-spacer></v-spacer>
                  <v-chip small color="white" outlined>Required</v-chip>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pa-6">
                  <v-alert type="danger" dense class="mb-6" color="#56bda3">
                    <v-row align="center">
                      <v-col>
                        <span class="font-weight-700">Note:</span> The bank
                        account should be in the name of the student or in joint
                        name with the student.
                      </v-col>
                    </v-row>
                  </v-alert>
                  <v-container fluid>
                    <v-row wrap>
                      <v-col cols="12" lg="6" md="6">
                        <v-row wrap>
                          <v-col cols="12" class="mt-4">
                            <label class="field-label">
                              Student Bank Account Number
                              <span class="required-asterisk">*</span>
                            </label>
                            <v-text-field
                              v-model="AccountNumber"
                              :rules="AccountNumberRules"
                              :type="show3 ? 'text' : 'password'"
                              placeholder="Enter Student Bank account number"
                              required
                              outlined
                              dense
                              hide-details="auto"
                              class="modern-input"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="mt-4">
                            <label class="field-label">
                              Re-enter Student Bank Account Number
                              <span class="required-asterisk">*</span>
                            </label>
                            <v-text-field
                              v-model="ReEnterAccountNumber"
                              :rules="ReEnterAccountNumberRules"
                              placeholder="Re-enter Student Bank account number"
                              required
                              outlined
                              dense
                              hide-details="auto"
                              class="modern-input"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="mt-4">
                            <label class="field-label">
                              Account Holder Name
                              <span class="required-asterisk">*</span>
                            </label>
                            <v-text-field
                              v-model="HolderName"
                              :rules="HolderNameRules"
                              outlined
                              dense
                              placeholder="Enter account holder name"
                              hide-details="auto"
                              class="modern-input"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <label class="field-label">
                              IFSC Code <span class="required-asterisk">*</span>
                            </label>
                            <div class="ifsc-input-wrapper">
                              <v-text-field
                                v-model="IfscNumber"
                                :rules="IfscCodeRules"
                                :disabled="isFieldDisbaled"
                                placeholder="Enter IFSC Code"
                                required
                                outlined
                                dense
                                hide-details="auto"
                                class="modern-input ifsc-input"
                              ></v-text-field>
                              <v-btn
                                v-if="IfscNumber"
                                @click="deleteIfscData"
                                color="error"
                                outlined
                                small
                                class="ifsc-delete-btn"
                                title="Delete IFSC data and clear form"
                              >
                                <v-icon size="18">mdi-trash-can</v-icon>
                              </v-btn>
                            </div>
                          </v-col>
                          <v-col v-if="FormFlag" cols="12" class="mt-6">
                            <v-card
                              class="bank-details-card"
                              elevation="0"
                              outlined
                            >
                              <v-card-title class="bank-card-header">
                                <v-icon left color="primary" size="24"
                                  >mdi-bank</v-icon
                                >
                                <span>Bank Account Details</span>
                              </v-card-title>
                              <v-divider></v-divider>
                              <v-card-text class="pa-6">
                                <v-row class="bank-details-row">
                                  <v-col cols="12" md="6">
                                    <div class="bank-detail-item">
                                      <span class="bank-detail-label">
                                        <v-icon x-small left color="primary"
                                          >mdi-bank-outline</v-icon
                                        >
                                        Bank Name
                                      </span>
                                      <p class="bank-detail-value">
                                        {{ BankName }}
                                      </p>
                                    </div>
                                  </v-col>
                                  <v-col cols="12" md="6">
                                    <div class="bank-detail-item">
                                      <span class="bank-detail-label">
                                        <v-icon x-small left color="primary"
                                          >mdi-store-outline</v-icon
                                        >
                                        Branch Name
                                      </span>
                                      <p class="bank-detail-value">
                                        {{ BranchName }}
                                      </p>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col cols="12" class="mt-6 text-center">
                            <v-btn
                              :disabled="!valid1"
                              @click.prevent="searchForm"
                              :loading="SearchFlag"
                              color="primary"
                              outlined
                              size="large"
                            >
                              <v-icon left>mdi-magnify</v-icon>
                              Search
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" lg="6" md="6">
                        <label class="field-label"
                          >First page of the student bank passbook or cheque
                          leaf
                          <span class="required-asterisk">*</span>
                        </label>
                        <div class="image-preview-container">
                          <div
                            v-if="PassBookImageCropping"
                            class="cropper-wrapper"
                          >
                            <cropper
                              :src="PassBookImageFile"
                              ref="passBookCropper"
                              :stencil-props="{
                                handlers: {},
                                movable: true,
                                scalable: true,
                                previewClass: 'preview',
                              }"
                              class="modern-cropper"
                            />
                            <div class="cropper-actions mt-3">
                              <v-btn
                                @click="cropAndUpload('passBook')"
                                color="success"
                                small
                                block
                                class="mb-2"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Apply Crop
                              </v-btn>
                              <v-btn
                                @click="cancelCrop('passBook')"
                                color="error"
                                small
                                outlined
                                block
                              >
                                <v-icon small left>mdi-close</v-icon>
                                Cancel
                              </v-btn>
                            </div>
                          </div>
                          <div
                            v-else
                            class="image-placeholder"
                            @click="triggerFileInput('passBook')"
                            @dragover.prevent="PassBookImageDragging = true"
                            @dragleave.prevent="PassBookImageDragging = false"
                            @drop.prevent="handleDrop($event, 'passBook')"
                            :class="{ dragging: PassBookImageDragging }"
                          >
                            <input
                              :ref="'passBookFileInput'"
                              type="file"
                              accept="image/jpeg,image/png"
                              @change="onFileSelected($event, 'passBook')"
                              style="display: none"
                            />
                            <div
                              v-if="!PassBookImagePreview"
                              class="placeholder-content"
                            >
                              <v-icon size="48" color="#002D72" class="mb-2"
                                >mdi-cloud-upload</v-icon
                              >
                              <p class="font-weight-600">Drag & Drop Here</p>
                              <p class="text-caption">
                                or click to select image
                              </p>
                            </div>
                            <v-img
                              v-else
                              :src="PassBookImagePreview"
                              contain
                              height="280"
                            />
                          </div>
                          <v-btn
                            v-if="PassBookImagePreview"
                            @click="removeImage('passBook')"
                            color="error"
                            variant="outlined"
                            class="mt-3"
                            size="small"
                            block
                          >
                            <v-icon small left>mdi-trash-can</v-icon>
                            Remove Image
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>

              <!-- Submit Section -->
              <v-card elevation="0" class="submit-section">
                <v-card-text class="text-center pa-8">
                  <upload-progress
                    :ProgessStart="progessStart"
                    :UploadPercentage="uploadPercentage"
                  ></upload-progress>

                  <div class="submit-buttons mt-6">
                    <v-btn
                      id="step12"
                      type="submit"
                      @click.prevent="confirmAlert(2)"
                      :loading="SubmitFlag"
                      outlined
                      color="primary"
                      class="mr-4 px-8"
                    >
                      <v-icon left> mdi-content-save </v-icon>
                      Save as Draft
                    </v-btn>
                    <v-btn
                      id="step12"
                      type="submit"
                      @click.prevent="confirmAlert(1)"
                      :loading="SubmitFlag"
                      color="primary"
                      class="px-8"
                    >
                      <v-icon left> mdi-check-circle </v-icon>
                      Final Submit
                    </v-btn>
                  </div>

                  <p class="mt-6 text-caption grey--text">
                    <v-icon small color="grey">mdi-information</v-icon>
                    Please review all information before final submission. Saved
                    drafts can be edited until the deadline.
                  </p>
                </v-card-text>
              </v-card>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  mixins: [common],
  components: {
    Cropper,
  },
  data() {
    return {
      TooltipShow1: false,
      SpecialCategoryOptions: [
        { text: "--Select--", value: "" },
        { text: "NA", value: 1 },
        { text: "Orphan", value: 2 },
        { text: "Specially abled", value: 3 },
        { text: "Single parent", value: 4 },
        { text: "Girl child", value: 5 },
      ],
      SpecialCategory: "",
      SpecialCategoryDocument: null,
      SpecialCategoryDocumentRules: [
        (v) =>
          this.SpecialCategory === 1 ||
          this.SpecialCategory === "" ||
          !!v ||
          "Special Category Document is required",
      ],

      ScholarshipType: "",
      ScholarshipTypeItems: [
        { text: "--Select--", value: "" },
        { text: "One time Scholarship", value: 1 },
        { text: "Empower her", value: 2 },
      ],
      ScholarshipTypeRules: [(v) => !!v || "Scholarship Type is required"],

      StudentClassNameOptions: [
        { text: "--Select--", value: "" },
        { text: "9 Std", value: 9 },
        { text: "10 Std", value: 10 },
        { text: "11 Std", value: 11 },
        { text: "12 Std", value: 12 },
      ],
      StudentClassName: "",
      StudentClassNameRules: [(v) => !!v || "Class name is required"],

      valid1: true,
      valid2: true,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      OverlayLoadingFlag: false,
      SubmitFlag: false,
      SearchFlag: false,
      SearchResultFlag: false,
      ShowFormFlag: false,
      NewTitleFlag: true,
      NotesFlag: false,
      rows: [],
      selected: [],
      search: "",
      CurrentYearId: 0,
      show3: false,

      CheckoutTableHeaders: [],

      tab: null,
      TabDisable1: false,
      TabDisable2: false,
      TabDisable3: false,
      isFieldDisbaled: false,

      TabFlag3: false,

      TotalAmount: 0,
      Contribution: [],

      TotalAmount1: 0,
      TotalAmount2: 0,

      BankName: "",
      BranchName: "",
      IfscCodeSearched: false,

      AccountNumber: "",
      AccountNumber: "",
      ReEnterAccountNumber: "",

      AccountNumberRules: [],

      ReEnterAccountNumberRules: [
        (v) => v <= this.AccountNumber || "Not match.",
      ],

      Member: {},
      Order: {},
      MemberFlag: false,

      PenaltySubscription: [],

      image: {
        src: "media/images/white-user.png",
        type: null,
      },

      newimage: "",
      selectedImage: "",

      // Drag-drop and cropper states for all image uploads
      StudentImageFile: null,
      StudentImagePreview: "",
      StudentImageCropping: false,
      StudentImageDragging: false,

      SpecialCategoryDocumentFile: null,
      SpecialCategoryDocumentPreview: "",
      SpecialCategoryDocumentCropping: false,
      SpecialCategoryDocumentDragging: false,

      AnnualIncomeLetterFile: null,
      AnnualIncomeLetterPreview: "",
      AnnualIncomeLetterCropping: false,
      AnnualIncomeLetterDragging: false,

      StudentMarkImageFile: null,
      StudentMarkImagePreview: "",
      StudentMarkImageCropping: false,
      StudentMarkImageDragging: false,

      RecommendationLetterFile: null,
      RecommendationLetterPreview: "",
      RecommendationLetterCropping: false,
      RecommendationLetterDragging: false,

      PassBookImageFile: null,
      PassBookImagePreview: "",
      PassBookImageCropping: false,
      PassBookImageDragging: false,

      MemberImage: { src: null },
      SpecialCategoryDocumentImage: { src: null, ImageUrl: null },

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      HolderNameRules: [],
      IfscCodeRules: [],
      SchoolCantactNumberRules: [],
      SchoolNameRules: [],
      SchoolAddressRules: [],

      PrincipalNameRules: [],

      AnnualIncomeRules: [],
      ParentOccupationRules: [],

      StudentContactNumberRules: [],

      progessStart: 0,
      uploadPercentage: 0,

      StudentName: "",
      StudentNameRules: [(v) => !!v || "Student name is required"],

      StudentGender: "",
      StudentGenderRules: [(v) => !!v || "Gender is required"],
      StudentGenderOptions: [
        { text: "--Select--", value: "" },
        { text: "Male", value: 1 },
        { text: "Female", value: 2 },
      ],

      SpecialCategory: "",
      SpecialCategoryRules: [(v) => !!v || "Special Category is required"],

      ParentName: "",
      ParentNameRules: [],

      TotalMark: "",
      TotalMarkRules: [(v) => !!v || "Total mark is required"],

      Percentage: "",
      PercentageRules: [(v) => !!v || "Percentage is required"],

      StudentContactNumber: "",
      StudentContactNumberRules: [
        (v) => !!v || "Student Contact Number is required",
      ],

      ParentOccupation: "",
      ParentOccupationRules: [],

      ParentContactNumber: "",
      ParentContactNumberRules: [],

      PrincipalName: "",
      PrincipalNameRules: [],

      SchoolAddress: "",
      SchoolAddressRules: [],

      SchoolName: "",
      SchoolNameRules: [],

      SchoolCantactNumber: "",
      SchoolCantactNumberRules: [],
      SponsorName: "",
      SponsorNameRules: [],
      HolderName: "",
      HolderNameRules: [],

      IfscNumber: "",
      IfscNumberRules: [],
      AccountNumber: "",
      AccountNumberRules: [],
      AnnualIncome: "",
      AnnualIncomeRules: [],

      RecommendationLetter: {},
      AnnualIncomeLetter: {},
      StudentMarkImage: {},
      StudentImage: {},
      PassBookImage: {},
      PassbookImagePath: "",
      IncomePath: "",
      StudentImagePath: "",
      RecommendationLetterImagePath: "",
      IncomeProofImagePath: "",
      MarksheetImagePath: "",
      MarkImagePath: "",

      uploadedImages: [],
      TotalImages: 0,

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      StudentScholarship: {},
    };
  },
  computed: {
    specialCategoryTitle() {
      if (this.SpecialCategory === 3) {
        return "Disability Certificate";
      } else if (this.SpecialCategory === 2 || this.SpecialCategory === 4) {
        return "Supporting Certificate";
      }
      return "Special Category Document";
    },
    specialCategoryLabel() {
      if (this.SpecialCategory === 3) {
        return "Disability Certificate from Government";
      } else if (this.SpecialCategory === 2 || this.SpecialCategory === 4) {
        return "Supporting Certificate from School";
      } else if (this.SpecialCategory === 5) {
        return "Special Category Document (Girl Child)";
      }
      return "Special Category Document";
    },
    specialCategoryNote() {
      if (this.SpecialCategory === 3) {
        return "Note: LP has to upload a disability certificate from the government when submitting application for physically challenged.";
      } else if (this.SpecialCategory === 2 || this.SpecialCategory === 4) {
        return "Note: Supporting certificate from school must be uploaded when applying under the category of single parent or orphan.";
      } else if (this.SpecialCategory === 5) {
        return "Supporting certificate/document must be uploaded for the Girl child category.";
      }
      return "";
    },
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.JciYearCode = tr.CurrentJciYearId;
        var YearName = tr.CurrentJciYearName;
        this.YearName = YearName;

        var MonthCode = this.$route.query.month;
        MonthCode = MonthCode == (null || undefined) ? 0 : MonthCode;
        console.log({ MonthCode });
        this.MonthCode = MonthCode;

        var tempDate1 = YearName + "-" + MonthCode + "-01";
        console.log({ tempDate1 });

        var tempDate2 = new Date(tempDate1);
        console.log({ tempDate2 });
        var MonthName = tempDate2.toLocaleString("en-us", { month: "long" });
        console.log({ MonthName });
        this.MonthName = MonthName;

        var MrfStartDate = tr.MrfStartDate;
        console.log({ MrfStartDate });

        this.FromDateMin = MrfStartDate;
        this.ToDateMin = MrfStartDate;

        var MrfEndDate = tr.MrfEndDate;
        console.log({ MrfEndDate });

        this.FromDateMax = MrfEndDate;
        this.ToDateMax = MrfEndDate;

        this.pageData();
      }
    },
    StudentScholarship: function () {
      console.log("watch StudentScholarship");
      var tr = this.StudentScholarship;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.StudentName = tr.StudentName;
        this.StudentContactNumber = tr.StudentContact;
        this.IfscNumber = tr.IfscCode;
        this.ParentContactNumber = tr.ParentContact;
        this.AccountNumber = tr.AccountNumber;
        this.ReEnterAccountNumber = tr.AccountNumber;
        this.Percentage = tr.Percentage;
        this.ParentName = tr.StudentParentName;
        this.StudentClassName = tr.ClassName;
        this.HolderName = tr.AccountHolderName;
        this.SponsorName = tr.SponserName;
        this.ParentOccupation = tr.ParentOccupation;
        this.AnnualIncome = tr.AnnualIncome;
        this.SchoolAddress = tr.SchoolAddress;
        this.SchoolCantactNumber = tr.SchoolCantactNumber;
        this.SchoolAddress = tr.SchoolAddress;
        this.SchoolName = tr.StudentSchoolName;
        this.PrincipalName = tr.PrincipalName;
        this.StudentGender = tr.GenderType;
        this.SpecialCategory = tr.SpecialCategoryType;
        this.ScholarshipType = tr.ScholarshipType;
        this.TotalMark = tr.TotalMark;
        this.Account = tr.Account;
        this.StudentImagePath = tr.StudentImagePath;
        this.RecommendationLetterImagePath = tr.RecommendationLetterImagePath;
        this.IncomeProofImagePath = tr.IncomeProofImagePath;
        this.MarksheetImagePath = tr.MarksheetImagePath;
        this.PassbookImagePath = tr.PassbookImagePath;
        // Load existing images into preview properties
        this.StudentImagePreview = tr.StudentImagePath;
        this.AnnualIncomeLetterPreview = tr.IncomeProofImagePath;
        this.StudentMarkImagePreview = tr.MarksheetImagePath;
        this.RecommendationLetterPreview = tr.RecommendationLetterImagePath;
        this.PassBookImagePreview = tr.PassbookImagePath;
        this.SpecialCategoryDocumentPreview =
          tr.SpecialCategoryDocumentImagePath;
      }
    },
    IfscNumber: function () {
      console.log("watch IfscNumber");
      var IfscNumberValue = this.IfscNumber;
      console.log({ IfscNumberValue });
    },
    SpecialCategory: function (val) {
      console.log("watch SpecialCategory", val);
      if (!val || val === 1 || val === "") {
        this.removeImage("specialCategory");
      }
    },
  },
  created() {
    this.MemberImage.src = this.currentPhoto;
  },
  methods: {
    // Drag-drop and cropper methods
    onFileSelected(event, uploadType) {
      const file = event.target.files?.[0];
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.setImageData(uploadType, e.target.result, file);
        };
        reader.readAsDataURL(file);
      }
    },

    handleDrop(event, uploadType) {
      const draggingProp = `${
        uploadType.charAt(0).toUpperCase() +
        uploadType.slice(1).replace(/([A-Z])/g, "Dragging")
      }Dragging`;
      this[
        `${uploadType.charAt(0).toUpperCase()}${uploadType.slice(1)}Dragging`
      ] = false;

      const files = event.dataTransfer.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (file.type.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.setImageData(uploadType, e.target.result, file);
          };
          reader.readAsDataURL(file);
        }
      }
    },

    setImageData(uploadType, dataUrl, file) {
      const mappings = {
        studentImage: {
          fileProp: "StudentImageFile",
          croppingProp: "StudentImageCropping",
        },
        specialCategory: {
          fileProp: "SpecialCategoryDocumentFile",
          croppingProp: "SpecialCategoryDocumentCropping",
        },
        annualIncome: {
          fileProp: "AnnualIncomeLetterFile",
          croppingProp: "AnnualIncomeLetterCropping",
        },
        studentMark: {
          fileProp: "StudentMarkImageFile",
          croppingProp: "StudentMarkImageCropping",
        },
        recommendation: {
          fileProp: "RecommendationLetterFile",
          croppingProp: "RecommendationLetterCropping",
        },
        passBook: {
          fileProp: "PassBookImageFile",
          croppingProp: "PassBookImageCropping",
        },
      };

      const props = mappings[uploadType];
      if (props) {
        this[props.fileProp] = dataUrl;
        this[props.croppingProp] = true;
      }
    },

    triggerFileInput(uploadType) {
      this.$refs[`${uploadType}FileInput`]?.click();
    },

    cropAndUpload(uploadType) {
      const mappings = {
        studentImage: {
          cropperRef: "cropper",
          previewProp: "StudentImagePreview",
          croppingProp: "StudentImageCropping",
          fileProp: "StudentImageFile",
        },
        specialCategory: {
          cropperRef: "specialCategoryCropper",
          previewProp: "SpecialCategoryDocumentPreview",
          croppingProp: "SpecialCategoryDocumentCropping",
          fileProp: "SpecialCategoryDocumentFile",
        },
        annualIncome: {
          cropperRef: "annualIncomeCropper",
          previewProp: "AnnualIncomeLetterPreview",
          croppingProp: "AnnualIncomeLetterCropping",
          fileProp: "AnnualIncomeLetterFile",
        },
        studentMark: {
          cropperRef: "markImageCropper",
          previewProp: "StudentMarkImagePreview",
          croppingProp: "StudentMarkImageCropping",
          fileProp: "StudentMarkImageFile",
        },
        recommendation: {
          cropperRef: "recommendationCropper",
          previewProp: "RecommendationLetterPreview",
          croppingProp: "RecommendationLetterCropping",
          fileProp: "RecommendationLetterFile",
        },
        passBook: {
          cropperRef: "passBookCropper",
          previewProp: "PassBookImagePreview",
          croppingProp: "PassBookImageCropping",
          fileProp: "PassBookImageFile",
        },
      };

      const props = mappings[uploadType];
      if (props && this.$refs[props.cropperRef]) {
        const { canvas } = this.$refs[props.cropperRef].getResult();
        if (canvas) {
          canvas.toBlob((blob) => {
            this[props.previewProp] = URL.createObjectURL(blob);
            this[props.croppingProp] = false;
          }, "image/png");
        }
      }
    },

    cancelCrop(uploadType) {
      const mappings = {
        studentImage: {
          fileProp: "StudentImageFile",
          croppingProp: "StudentImageCropping",
        },
        specialCategory: {
          fileProp: "SpecialCategoryDocumentFile",
          croppingProp: "SpecialCategoryDocumentCropping",
        },
        annualIncome: {
          fileProp: "AnnualIncomeLetterFile",
          croppingProp: "AnnualIncomeLetterCropping",
        },
        studentMark: {
          fileProp: "StudentMarkImageFile",
          croppingProp: "StudentMarkImageCropping",
        },
        recommendation: {
          fileProp: "RecommendationLetterFile",
          croppingProp: "RecommendationLetterCropping",
        },
        passBook: {
          fileProp: "PassBookImageFile",
          croppingProp: "PassBookImageCropping",
        },
      };

      const props = mappings[uploadType];
      if (props) {
        this[props.fileProp] = null;
        this[props.croppingProp] = false;
      }
    },

    removeImage(uploadType) {
      const mappings = {
        studentImage: {
          previewProp: "StudentImagePreview",
          fileProp: "StudentImageFile",
        },
        specialCategory: {
          previewProp: "SpecialCategoryDocumentPreview",
          fileProp: "SpecialCategoryDocumentFile",
        },
        annualIncome: {
          previewProp: "AnnualIncomeLetterPreview",
          fileProp: "AnnualIncomeLetterFile",
        },
        studentMark: {
          previewProp: "StudentMarkImagePreview",
          fileProp: "StudentMarkImageFile",
        },
        recommendation: {
          previewProp: "RecommendationLetterPreview",
          fileProp: "RecommendationLetterFile",
        },
        passBook: {
          previewProp: "PassBookImagePreview",
          fileProp: "PassBookImageFile",
        },
      };

      const props = mappings[uploadType];
      if (props) {
        this[props.previewProp] = "";
        this[props.fileProp] = null;
        const refName = `${uploadType}FileInput`;
        if (this.$refs[refName]) {
          this.$refs[refName].value = "";
        }
      }
    },

    backPage() {
      this.$router.go(-1);
    },
    resetForm() {
      this.$refs.form1.reset();
      this.Member = {};
    },
    refreshPageData() {
      console.log("pageData called");
      var StudentId = this.$route.query.id;
      console.log({ StudentId });
      this.StudentId = StudentId;

      var ZoneName = this.$session.get("ZoneName");
      ZoneName = ZoneName == (null || undefined) ? "" : ZoneName;
      console.log({ ZoneName });
      this.ZoneName = ZoneName;

      var ZoneCode = this.$session.get("ZoneId");
      ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
      console.log({ ZoneCode });
      this.ZoneCode = ZoneCode;

      var LomCode = this.$session.get("LomId");
      LomCode = LomCode == (null || undefined) ? "" : LomCode;
      console.log({ LomCode });
      this.LomCode = LomCode;

      var LomName = this.$session.get("LomName");
      LomName = LomName == (null || undefined) ? "" : LomName;
      console.log({ LomName });
      this.LomName = LomName;

      var CurrentDesignation = this.$session.get("CurrentDesignation");
      CurrentDesignation =
        CurrentDesignation == (null || undefined) ? "" : CurrentDesignation;
      console.log({ CurrentDesignation });
      this.CurrentDesignation = CurrentDesignation;

      var MemeberFullname = this.$session.get("MemeberFullname");
      MemeberFullname =
        MemeberFullname == (null || undefined) ? "" : MemeberFullname;
      console.log("MemeberFullname=" + MemeberFullname);
      this.MemeberFullname = MemeberFullname;

      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "student_scholarship",
        Action: "edit",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      this.getStudentDetails();
    },
    getStudentDetails() {
      console.log(" getStudentDetails is called");
      var StudentId = this.StudentId;

      if (StudentId > 0) {
        var upload = {
          UserInterface: 1,
          Student: StudentId,
        };
        console.log({ upload });

        this.StudentScholarship = {};
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/show";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = {};
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.StudentScholarship = records;
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        var message = "";
        if (StudentId == "") {
          message += "Scholarship details not found.";
        }
        this.sweetAlert("error", message, false);
      }
    },
    confirmAlert(status) {
      console.log("confirmAlert called");
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      console.log("status" + status);

      if (validate1) {
        // Check if IFSC code is provided but not searched
        if (this.IfscNumber && !this.IfscCodeSearched) {
          this.sweetAlert(
            "error",
            "Please search IFSC code first before submitting",
            false
          );
          return;
        }

        if (
          status == 1 &&
          this.SpecialCategory &&
          this.SpecialCategory !== 1 &&
          this.SpecialCategory !== ""
        ) {
          if (!this.SpecialCategoryDocumentPreview) {
            let docName = "Special Category Document";
            if (this.SpecialCategory === 3) {
              docName = "Disability Certificate from Government";
            } else if (
              this.SpecialCategory === 2 ||
              this.SpecialCategory === 4
            ) {
              docName = "Supporting Certificate from School";
            }
            this.sweetAlert(
              "error",
              `Please upload the ${docName} before final submission.`,
              false
            );
            return;
          }
        }

        var htmlTxt = "";
        var title = "";
        if (status == 1) {
          title = "Final Submit?";
          htmlTxt +=
            "<h6> You are about to final submit this application. If you click yes, you cannot edit it anymore. Do you want to continue?</h6>";
        } else {
          title = "Save?";
          htmlTxt +=
            "<h6> You are partially saving this application. You can edit it till the deadline. Do you want to continue?</h6>";
        }

        Swal.fire({
          title: title,
          text: "Please verify all the information before proceeding.",
          icon: "warning",
          html: htmlTxt,
          showCancelButton: true,
          confirmButtonText: `Continue`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.getCroppedImage(status);
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    searchForm() {
      console.log("searchForm called");
      this.SearchFlag = true;
      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/get-bank-details";
      var upload = {
        IfscCode: this.IfscNumber,
      };
      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = "";
      var flag = 0;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          thisIns.SearchFlag = false;
          console.log("response=" + JSON.stringify(response));

          // thisIns.pageLoadingOff()
          thisIns.SubmitFlag = false;

          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          if (flag == 1) {
            thisIns.BankName = records.BankName;
            thisIns.BranchName = records.BranchName;
            thisIns.IfscCodeSearched = true; // Set flag when IFSC search is successful
            thisIns.isFieldDisbaled = true; // Disable IFSC field after successful search
            console.log("BankName" + thisIns.BankName);
            console.log("BranchName" + thisIns.BranchName);

            thisIns.FormFlag = true;
            console.log("FormFlag" + thisIns.FormFlag);
          } else {
            thisIns.IfscCodeSearched = false; // Reset flag on error
            thisIns.isFieldDisbaled = false; // Keep field enabled on error
            thisIns.sweetAlert("error", output, false);
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SubmitFlag = false;
          thisIns.IfscCodeSearched = false;
        });
    },

    deleteIfscData() {
      console.log("deleteIfscData called");
      Swal.fire({
        title: "Delete IFSC Code?",
        text: "Are you sure you want to clear the IFSC code and bank details?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete",
        confirmButtonColor: "#d33",
        cancelButtonText: "Cancel",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.isConfirmed) {
          this.IfscNumber = "";
          this.BankName = "";
          this.BranchName = "";
          this.IfscCodeSearched = false;
          this.isFieldDisbaled = false; // Enable IFSC field again
          this.FormFlag = false;
          this.sweetAlert("success", "IFSC code cleared successfully", false);
        }
      });
    },
    getCroppedImage(status) {
      console.log("getCroppedImage is called");
      console.log("status", status);

      const validate1 = this.$refs.form1.validate();
      console.log("validate1 =", validate1);

      if (!validate1) {
        this.sweetAlert("error", "Kindly fill the required fields", false);
        return;
      }

      var BankInfoId = this.StudentScholarship.BankInfoId;
      console.log("BankInfoId=" + BankInfoId);

      var AttachmentId = this.StudentScholarship.AttachmentId;
      console.log("AttachmentId=" + AttachmentId);

      var StudentId = this.StudentScholarship.StudentId;
      console.log("StudentId=" + StudentId);

      var MarkId = this.StudentScholarship.MarkId;
      console.log("MarkId=" + MarkId);

      // Create FormData object
      let StudentData = {
        StudentBankInfoId: BankInfoId,
        StudentMarkId: MarkId,
        StudentId: StudentId,
        StudentAttachmentId: AttachmentId,
        StudentName: this.StudentName,
        SpecialCategory: this.SpecialCategory,
        TotalMark: this.TotalMark,
        Percentage: this.Percentage,
        ScholarshipType: this.ScholarshipType,
        StudentGender: this.StudentGender,
        ParentName: this.ParentName,
        StudentClassName: this.StudentClassName,
        StudentContactNumber: this.StudentContactNumber,
        ParentOccupation: this.ParentOccupation,
        ParentContactNumber: this.ParentContactNumber,
        PrincipalName: this.PrincipalName,
        SchoolAddress: this.SchoolAddress,
        SchoolCantactNumber: this.SchoolCantactNumber,
        SponsorName: this.SponsorName,
        HolderName: this.HolderName,
        IfscNumber: this.IfscNumber,
        AccountNumber: this.AccountNumber,
        AnnualIncome: this.AnnualIncome,
        SchoolName: this.SchoolName,
        BankName: this.BankName,
        BranchName: this.BranchName,
        UserInterface: status,
      };
      console.log({ StudentData });

      let upload = new FormData();
      upload.append("UserInterface", status);
      upload.append("Form", JSON.stringify(StudentData));

      // Handle all image files
      const imageTypeMappings = [
        {
          preview: "StudentImagePreview",
          file: "StudentImageFile",
          key: "StudentImage",
          cropper: "cropper",
        },
        {
          preview: "AnnualIncomeLetterPreview",
          file: "AnnualIncomeLetterFile",
          key: "AnnualIncomeLetter",
          cropper: null,
        },
        {
          preview: "StudentMarkImagePreview",
          file: "StudentMarkImageFile",
          key: "StudentMarkImage",
          cropper: null,
        },
        {
          preview: "RecommendationLetterPreview",
          file: "RecommendationLetterFile",
          key: "RecommendationLetter",
          cropper: null,
        },
        {
          preview: "PassBookImagePreview",
          file: "PassBookImageFile",
          key: "PassBookImage",
          cropper: null,
        },
        {
          preview: "SpecialCategoryDocumentPreview",
          file: "SpecialCategoryDocumentFile",
          key: "SpecialCategoryDocument",
          cropper: null,
        },
      ];

      // Add each image to FormData
      let pendingBlobConversions = 0;
      const blobConversionPromises = [];

      imageTypeMappings.forEach((mapping) => {
        const preview = this[mapping.preview];

        if (preview) {
          // Check if it's a blob URL (new upload with cropper)
          if (preview.includes("blob:")) {
            pendingBlobConversions++;
            // Convert blob URL to blob
            fetch(preview)
              .then((res) => res.blob())
              .then((blob) => {
                upload.append(mapping.key, blob, `${mapping.key}.png`);
                pendingBlobConversions--;
                if (pendingBlobConversions === 0) {
                  this.submitForm(upload);
                }
              })
              .catch((error) => {
                console.error(
                  `Error converting blob for ${mapping.key}:`,
                  error
                );
                pendingBlobConversions--;
                if (pendingBlobConversions === 0) {
                  this.submitForm(upload);
                }
              });
          } else {
            // It's an existing image path from server
            upload.append(mapping.key, preview);
          }
        }
      });

      // If there are no pending blob conversions, submit immediately
      if (pendingBlobConversions === 0) {
        this.submitForm(upload);
      }
    },
    submitForm(upload) {
      console.log("submitForm is called");
      console.log({ upload });

      const validate1 = this.$refs.form1.validate();
      console.log("validate1 =", validate1);

      var message = "";

      if (validate1) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/student/update";

        console.log(
          "server_url =",
          server_url,
          "token =",
          token,
          "add_url =",
          add_url
        );

        this.OverlayLoadingFlag = true;
        this.SubmitFlag = true;

        const thisIns = this;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then((response) => {
            console.log("response =", response);

            thisIns.SubmitFlag = false;
            thisIns.OverlayLoadingFlag = false;
            thisIns.progessStart = 0;

            const { flag, output } = response.data;
            console.log("output =", output, "flag =", flag);

            if (flag == 1) {
              thisIns.$router.push("/student-scholarship/list");
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch((error) => {
            console.error("error =", error);
            thisIns.progessStart = 0;
            thisIns.SubmitFlag = false;
            thisIns.OverlayLoadingFlag = false;
            thisIns.sweetAlert(
              "error",
              "Error submitting form. Please try again.",
              false
            );
          });
      } else {
        if (!validate1) {
          message = "Kindly fill the required fields";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
  mounted: function () {},
};
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap");

#lom-events-create {
  background-color: #f0f4f8;
  min-height: 100vh;
  font-family: "Outfit", "Inter", sans-serif !important;

  /* Premium Header */
  .premium-header-section {
    background: linear-gradient(135deg, #002d72 0%, #00a9e0 100%);
    position: relative;
    padding: 60px 0 100px 0;
    color: white;
    overflow: hidden;

    .header-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url("https://www.transparenttextures.com/patterns/cubes.png");
      opacity: 0.1;
      pointer-events: none;
    }

    .header-content-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      z-index: 1;

      .breadcrumb-container {
        font-size: 0.85rem;
        font-weight: 500;
        opacity: 0.8;
        display: flex;
        align-items: center;
        gap: 4px;

        .breadcrumb-item.active {
          color: #ffb81c;
        }
      }

      .premium-page-title {
        font-size: 2.5rem;
        font-weight: 800;
        letter-spacing: -0.5px;
        margin: 0;
        line-height: 1.2;
      }

      .premium-page-subtitle {
        font-size: 1.1rem;
        opacity: 0.9;
        margin-top: 8px;
        font-weight: 300;
      }

      .glass-btn {
        background: rgba(255, 255, 255, 0.15) !important;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: white !important;
        text-transform: none;
        font-weight: 600;
        padding: 0 24px !important;
        height: 44px;

        &:hover {
          background: rgba(255, 255, 255, 0.25) !important;
        }
      }

      .refresh-btn {
        text-transform: none;
        font-weight: 700;
        padding: 0 24px !important;
        height: 44px;
        color: #002d72 !important;
      }
    }
  }

  /* Main Glass Card */
  .glass-main-card {
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    margin-bottom: 40px;
    box-shadow: 0 20px 40px rgba(0, 45, 114, 0.08) !important;
  }

  /* Welcome Card */
  .premium-welcome-card {
    background: white !important;
    border-radius: 16px;
    border-left: 6px solid #ffb81c;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03) !important;
    overflow: hidden;

    .welcome-avatar-wrapper {
      position: relative;

      .v-avatar {
        background: #f0f7ff !important;
        border: 4px solid white;
      }

      .avatar-badge {
        position: absolute;
        bottom: 5px;
        right: 5px;
        background: #00b388;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid white;
      }
    }

    .welcome-label {
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: 700;
      color: #94a3b8;
      letter-spacing: 1px;
    }

    .welcome-title {
      color: #002d72;
      font-size: 1.8rem;
      font-weight: 700;
    }

    .welcome-meta {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-top: 8px;

      .meta-item {
        font-size: 0.95rem;
        color: #64748b;
        font-weight: 500;
        display: flex;
        align-items: center;
      }

      .meta-divider {
        width: 4px;
        height: 4px;
        background: #cbd5e1;
        border-radius: 50%;
      }
    }

    .year-badge {
      background: #f8fafc;
      padding: 12px 20px;
      border-radius: 12px;
      text-align: right;
      border: 1px solid #e2e8f0;

      .year-label {
        display: block;
        font-size: 0.7rem;
        color: #94a3b8;
        font-weight: 700;
        text-transform: uppercase;
      }

      .year-value {
        font-size: 1.1rem;
        color: #002d72;
        font-weight: 700;
      }
    }
  }

  /* Section Cards */
  .section-card {
    background: #ffffff !important;
    border-radius: 16px !important;
    border: 1px solid #e2e8f0 !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      box-shadow: 0 10px 25px rgba(0, 45, 114, 0.05) !important;
      border-color: #00a9e0 !important;
    }

    .section-header {
      padding: 24px 30px !important;
      background: linear-gradient(135deg, #002d72 0%, #00a9e0 100%) !important;
      border-radius: 16px 16px 0 0;

      .section-title {
        font-size: 1.25rem;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: -0.3px;
      }

      .v-chip {
        font-weight: 700;
        font-size: 0.7rem;
        height: 24px;
      }
    }

    .subsection-title {
      font-size: 1.1rem;
      font-weight: 700;
      color: #002d72;
      display: flex;
      align-items: center;
      border-bottom: 2px solid #f1f5f9;
      padding-bottom: 12px;
    }
  }

  /* Form Fields Styling */
  .field-label {
    display: block;
    margin-bottom: 8px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #475569;

    .required-asterisk {
      color: #ef4444;
      margin-left: 2px;
    }
  }

  .modern-input {
    .v-input__slot {
      border-radius: 12px !important;
      background-color: #f8fafc !important;
      border: 1px solid #e2e8f0 !important;
      box-shadow: none !important;
      transition: all 0.2s ease;

      fieldset {
        border: none !important;
      }

      &:hover {
        background-color: #f1f5f9 !important;
        border-color: #cbd5e1 !important;
      }
    }

    &.v-input--is-focused .v-input__slot {
      background-color: #ffffff !important;
      border-color: #00a9e0 !important;
      box-shadow: 0 0 0 4px rgba(0, 169, 224, 0.1) !important;
    }

    .v-label {
      color: #94a3b8 !important;
    }

    input,
    .v-select__selection {
      color: #1e293b !important;
      font-weight: 500;
    }
  }

  /* File Inputs */
  .v-file-input {
    .v-input__prepend-outer {
      margin-top: 10px;
    }

    .v-file-input__text {
      font-size: 0.9rem;
    }
  }

  /* Action Buttons */
  .submit-section {
    background: #f8fafc;
    border-radius: 0 0 20px 20px;
    border-top: 1px solid #e2e8f0;

    .submit-buttons {
      .v-btn {
        height: 56px !important;
        border-radius: 12px !important;
        text-transform: none !important;
        font-weight: 700 !important;
        font-size: 1.05rem !important;
        letter-spacing: 0.5px !important;
        padding: 0 40px !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &.v-btn--outlined {
          border: 2px solid #00a9e0 !important;
          color: #00a9e0 !important;

          &:hover {
            background: rgba(0, 169, 224, 0.05) !important;
            transform: translateY(-2px);
          }
        }

        &:not(.v-btn--outlined) {
          background: linear-gradient(
            135deg,
            #002d72 0%,
            #00a9e0 100%
          ) !important;
          box-shadow: 0 8px 20px rgba(0, 45, 114, 0.15) !important;

          &:hover {
            box-shadow: 0 12px 25px rgba(0, 45, 114, 0.25) !important;
            transform: translateY(-2px);
          }
        }
      }
    }
  }

  /* Cropper Card */
  .cropper-card {
    border-radius: 16px;
    border: 2px dashed #e2e8f0 !important;
    background: #f8fafc;

    .v-card__subtitle {
      font-weight: 700;
      color: #64748b;
    }

    .modern-cropper {
      height: 350px;
      border-radius: 12px;
      margin: 10px;
      overflow: hidden;
    }
  }

  /* Image Controls */
  .image-controls {
    .v-btn {
      border-radius: 8px !important;
      text-transform: none !important;
      font-weight: 600 !important;
    }
  }

  /* Drag-Drop and Cropper Styles */
  .image-preview-container {
    width: 100%;
  }

  .cropper-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .modern-cropper {
    height: 300px;
    background: #f0f4f8;
    border-radius: 12px;
    overflow: hidden;
    border: 2px solid #e0e7ff;
  }

  .cropper-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .v-btn {
      border-radius: 8px !important;
      font-weight: 600 !important;
      text-transform: none !important;
    }
  }

  .image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 280px;
    background: #ffffff;
    border-radius: 12px;
    border: 2px dashed #002d72;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
      border-color: #002d72;
      background: #f8faff;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 45, 114, 0.15);
    }

    &.dragging {
      border-color: #002d72 !important;
      border-style: solid !important;
      background: #f0f3ff !important;
      box-shadow: 0 12px 30px rgba(0, 45, 114, 0.25) !important;
      transform: scale(1.01);
    }
  }

  .placeholder-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: #002d72;
    text-align: center;

    p {
      margin: 0;
      font-size: 0.95rem;
      color: #002d72;
    }
  }

  .preview-image {
    border-radius: 12px;
    width: 100%;
    height: 100%;
  }

  /* Alerts */
  .v-alert {
    border-radius: 12px;
    font-weight: 500;

    &.v-alert--outlined {
      background: white !important;
    }
  }

  /* IFSC Input Wrapper */
  .ifsc-input-wrapper {
    display: flex;
    gap: 8px;
    align-items: flex-start;

    .ifsc-input {
      flex: 1;
    }

    .ifsc-delete-btn {
      margin-top: 2px;
      padding: 8px 8px !important;
      min-width: auto !important;
      height: 40px !important;
      border-radius: 8px !important;
    }
  }

  /* Bank Details Card */
  .bank-details-card {
    background: linear-gradient(135deg, #f0f7ff 0%, #e3f2fd 100%) !important;
    border: 2px solid #00a9e0 !important;
    border-radius: 16px !important;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      box-shadow: 0 12px 30px rgba(0, 169, 224, 0.15) !important;
      transform: translateY(-2px);
    }

    .bank-card-header {
      background: linear-gradient(135deg, #002d72 0%, #00a9e0 100%) !important;
      color: white !important;
      padding: 18px 24px !important;
      font-weight: 700 !important;
      font-size: 1.1rem !important;
      letter-spacing: 0.3px;

      .v-icon {
        margin-right: 8px;
      }
    }

    .bank-details-row {
      padding: 0;

      .bank-detail-item {
        background: white;
        padding: 18px;
        border-radius: 12px;
        border: 1px solid #e0f2fe;
        transition: all 0.3s ease;

        &:hover {
          border-color: #00a9e0;
          box-shadow: 0 4px 12px rgba(0, 169, 224, 0.08);
        }

        .bank-detail-label {
          display: flex;
          align-items: center;
          font-size: 0.8rem;
          font-weight: 700;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 10px;

          .v-icon {
            margin-right: 6px;
          }
        }

        .bank-detail-value {
          margin: 0;
          font-size: 1.15rem;
          font-weight: 700;
          color: #002d72;
          word-break: break-word;
        }
      }
    }
  }

  /* Responsive Adjustments */
  @media (max-width: 600px) {
    .premium-header-section {
      padding: 40px 0 80px 0;

      .premium-page-title {
        font-size: 1.8rem;
      }

      .header-content-wrapper {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
      }
    }

    .premium-welcome-card {
      text-align: center;
      .v-row {
        justify-content: center;
      }
      .welcome-meta {
        justify-content: center;
        flex-direction: column;
        gap: 8px;

        .meta-divider {
          display: none;
        }
      }
    }

    .submit-buttons {
      flex-direction: column;
      gap: 12px;

      .v-btn {
        width: 100%;
        margin-right: 0 !important;
      }
    }
  }

  /* Animations */
  @keyframes slideInUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .glass-main-card {
    animation: slideInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }
}
</style>